]<!-- =========================================================================================
    File Name: Faq.vue
    Description: FAQ Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="faq-page">
        <!-- JUMBOTRON -->
        <div class="faq-jumbotron">
            <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
                <h1 class="mb-1">GrapePerks explained</h1>
                <p>Answers to frequently asked questions.</p>
                <vs-input placeholder="Search" v-model="faqSearchQuery" icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6" icon-no-border />
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full md:w-2/5 lg:w-1/4 rounded-lg">
                <vx-card>
                    <h4>Table of contents</h4>
                    <ul class="faq-topics mt-4">
                        <li v-for="category in categories" :key="category.id" class="p-2 font-medium flex items-center" @click="faqFilter = category.id">
                            <div class="h-3 w-3 rounded-full mr-2" :class="'bg-' + category.color"></div><span class="cursor-pointer">{{ category.name }}</span>
                        </li>
                    </ul>

                    <br><br>
                    <!--
                    <h4>Supporters</h4>
                    <ul class="faq-supporters mt-4">
                        <li v-for="supporter in supporters" :key="supporter.id" class="mt-4">
                            <div class="flex items-center">
                                <vs-avatar class="mr-3" :src="supporter.img" size="35px" />
                                <div class="leading-tight">
                                    <p class="font-semibold">{{ supporter.name }}</p>
                                    <small>{{ supporter.profession }}</small>
                                </div>
                            </div>
                        </li>
                    </ul>
                    -->
                </vx-card>
            </div>

            <!-- FAQ COL -->
            <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
                <vs-collapse accordion type="margin" class="p-0">
                    <vs-collapse-item v-for="(que,index) in filteredFaq" class="faq-bg rounded-lg" :class="{'mt-0': !index}" :key="que.id">
                        <div slot="header"><h5>{{ que.question }}</h5></div>
                        <p v-html="que.ans"></p>
                    </vs-collapse-item>
                </vs-collapse>

            </div>
        </div>
    </div>
</template>

<script>

export default{
    data() {
        return {
            faqSearchQuery: '',
            faqFilter: 1,
            categories: [
                {
                    id: 1,
                    name: 'All',
                    color: 'grey',
                },
                {
                    id: 2,
                    name: 'General',
                    color: 'primary'
                },
                {
                    id: 3,
                    name: 'Billing & Pricing',
                    color: 'success'
                },
                {
                    id: 4,
                    name: 'Account & Campaigns',
                    color: 'warning'
                },
                {
                    id: 5,
                    name: 'Compliance',
                    color: 'danger'
                },
            ],
            faqs: [
                {
                    id: 1,
                    categoryId: 2,
                    question: 'What is GrapePerks?',
                    ans: 'GrapePerks is a customer engagement platform that helps businesses connect with their customers through SMS campaigns, manage online reviews, and build waiting lists. Our goal is to provide powerful, easy-to-use tools to improve customer communication and grow your business.'
                },
                {
                    id: 2,
                    categoryId: 2,
                    question: 'Who can benefit from using GrapePerks?',
                    ans: 'Any business that communicates with customers can benefit from our platform, including retail stores, restaurants, salons, and service providers. If you want to send targeted SMS campaigns, improve your online reputation, or manage customer demand, GrapePerks is for you.'
                },
                {
                    id: 3,
                    categoryId: 4,
                    question: 'How do I set up my account?',
                    ans: 'You can set up your account by navigating to Account > Details from the user menu in the top right. Here, you can enter your personal and business information. For a complete guide, please see our <a href="/documentation/accounts/how-do-i-set-up-my-basic-account-information">account setup documentation</a>.'
                },
                {
                    id: 4,
                    categoryId: 4,
                    question: 'How do I create and schedule an SMS campaign?',
                    ans: 'To create an SMS campaign, go to the "Campaigns" section, where you can select your audience, compose your message, and schedule it to be sent. For more detailed instructions, please visit our <a href="/documentation/sms-campaigns/how-to-create-a-new-sms-campaign">SMS campaigns documentation</a>.'
                },
                {
                    id: 5,
                    categoryId: 4,
                    question: 'How can I collect customer reviews?',
                    ans: 'You can request reviews by setting up a review campaign in the "Reviews" section of the dashboard. This allows you to automatically ask for reviews after a customer interacts with your business. Learn more in our <a href="/documentation/reviews/how-to-request-reviews-from-customers">reviews documentation</a>.'
                },
                {
                    id: 6,
                    categoryId: 4,
                    question: 'How does the waitlist feature work?',
                    ans: 'The waitlist allows you to capture customer details when you are fully booked. You can set up your waitlist form from the "Waitlist" section and embed it on your website. For more details, see our <a href="/documentation/waitlist/how-to-complete-the-waitlist-configuration">waitlist documentation</a>.'
                },
                {
                    id: 7,
                    categoryId: 5,
                    question: 'What are my legal obligations when sending SMS messages?',
                    ans: 'When sending SMS messages, you must comply with regulations such as the Spam Act in Australia, GDPR in the EU, and the TCPA in the USA. This includes getting consent and providing an opt-out. For more information, please read our <a href="/documentation/compliance/what-are-the-legal-requirements-for-sending-sms-messages">compliance documentation</a>.'
                },
                {
                    id: 8,
                    categoryId: 3,
                    question: 'How does GrapePerks billing work?',
                    ans: 'GrapePerks uses a pay-as-you-go model for SMS messages. You prepay to add credit to your account and are charged only for the messages you send. There are no mandatory monthly subscription fees.'
                },
                {
                    id: 9,
                    categoryId: 3,
                    question: 'Are there any monthly fees?',
                    ans: 'No, there are no mandatory monthly fees. Your account is free to maintain, and you only pay for the messages you send. An optional dedicated virtual number is available for a monthly fee.'
                },
                {
                    id: 10,
                    categoryId: 5,
                    question: 'Do I need a privacy policy?',
                    ans: 'Yes, having a privacy policy is a legal requirement in most regions and is essential for building trust with your customers. You can create one in your account settings under the "Policies" tab. For more guidance, see our <a href="/documentation/compliance/how-to-create-a-privacy-policy">compliance documentation</a>.'
                },
                {
                    id: 11,
                    categoryId: 3,
                    question: 'Is there a free account option?',
                    ans: 'Yes, GrapePerks offers free accounts with no time limit. You can sign up and explore all our features without any commitment. You only pay for the SMS messages you send and any optional dedicated numbers you choose to purchase.'
                },
                {
                    id: 12,
                    categoryId: 2,
                    question: 'Is my data secure with GrapePerks?',
                    ans: 'Yes, we take security seriously. We use industry-standard encryption for all data and offer two-factor authentication to keep your account secure. For more information, please see our <a href="/documentation/accounts/how-is-my-account-data-protected">security documentation</a>.'
                }
            ],
            supporters: [
                {
                    id: 1,
                    img: require("@/assets/img/vuexy/portrait/small/avatar-s-1.jpg"),
                    name: 'Boyce Shene',
                    profession: 'Web Developer'
                },
                {
                    id: 2,
                    img: require("@/assets/img/vuexy/portrait/small/avatar-s-2.jpg"),
                    name: 'Margie Sevy',
                    profession: 'Web Designer'
                },
                {
                    id: 3,
                    img: require("@/assets/img/vuexy/portrait/small/avatar-s-3.jpg"),
                    name: 'Cyndi Navas',
                    profession: 'Web Developer'
                },
                {
                    id: 4,
                    img: require("@/assets/img/vuexy/portrait/small/avatar-s-4.jpg"),
                    name: 'Chi Petrusky',
                    profession: 'Web Developer'
                },
                {
                    id: 5,
                    img: require("@/assets/img/vuexy/portrait/small/avatar-s-5.jpg"),
                    name: 'Shanel Dumag',
                    profession: 'Web Designer'
                },
            ]
        }
    },
    computed: {
        filteredFaq() {
            return this.faqs.filter((faq) => {
                if (this.faqFilter == 1) return (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 2) return faq.categoryId == 2 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 3) return faq.categoryId == 3 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 4) return faq.categoryId == 4 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
                else if (this.faqFilter == 5) return faq.categoryId == 5 && (faq.question.toLowerCase().includes(this.faqSearchQuery.toLowerCase()) || faq.ans.toLowerCase().includes(this.faqSearchQuery.toLowerCase()));
            });
        }
    },
    methods: {
    },
    components: {
    }
}
</script>

<style lang="scss">
#faq-page {
    .faq-jumbotron-content {
        background-image: url('../../assets/img/documentation/faqs-background.jpg');
        background-size: cover;
    }

    .faq-bg {
        background-color: #fff;
    }
}
</style>
